import React from "react";
import { DataManProps } from "./DataMan.types";
import { DataManBody } from "./components/DataManBody";
import { DataManProvider } from "./providers/DataManProvider";
import { DataManDataBase } from "./types/common";

export function DataMan<TData extends DataManDataBase, TValue>(
  props: DataManProps<TData, TValue>
) {
  const { ...initialState } = props;

  return (
    <DataManProvider {...initialState}>
      <DataManBody />
    </DataManProvider>
  );
}
